<script>
import ElCollapseItem from 'element-ui/packages/collapse/src/collapse-item'

export default {
  name: 'ElCollapseItem',
  extends: ElCollapseItem,
  methods: {
    // Element 的鼠标分支会拦截 disabled，键盘分支也必须保持相同语义。
    handleEnterClick () {
      if (this.disabled) return
      ElCollapseItem.methods.handleEnterClick.call(this)
    }
  }
}
</script>
